
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/functions/handling-webhooks",
      function () {
        return require("private-next-pages/events/functions/handling-webhooks.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/functions/handling-webhooks"])
      });
    }
  